import { render, staticRenderFns } from "./RefundRequestsTable.vue?vue&type=template&id=426dc96c"
import script from "./RefundRequestsTable.vue?vue&type=script&lang=js"
export * from "./RefundRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports